<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10w8Y1h/tc-custom/9780062326164.jpg?1720012176247" alt="This image is the cover for the book Memory of Water"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memory of Water
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An amazing, award-winning speculative fiction debut novel by a major new talent, in the vein of Ursula K. Le Guin.</b></p><p>Global warming has changed the world’s geography and its politics. Wars are waged over water, and China rules Europe, including the Scandinavian Union, which is occupied by the power state of New Qian. In this far north place, seventeen-year-old Noria Kaitio is learning to become a tea master like her father, a position that holds great responsibility and great secrets. Tea masters alone know the location of hidden water sources, including the natural spring that Noria’s father tends, which once provided water for her whole village.</p><p>But secrets do not stay hidden forever, and after her father’s death the army starts watching their town—and Noria. And as water becomes even scarcer, Noria must choose between safety and striking out, between knowledge and kinship.</p><p>Imaginative and engaging, lyrical and poignant, <i>Memory of Water</i> is an indelible novel that portrays a future that is all too possible.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emmi Itäranta
      </h2>
      
      <p class="authorDescription body article"><P>Emmi It&#228;ranta&#160;writes fiction in Finnish and English. Her professional background is an eclectic mix of writing-related activities, including stints as a columnist, theatre critic, scriptwriter and press officer. She is the author of <I>Memory of Water</I> and lives in Canterbury, England.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a248a682